import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  IconButton,
  Popover,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import k1 from "../assets/k1.png";
import k2 from "../assets/k2.png";
import StarIcon from "@mui/icons-material/Star";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import InfoIcon from "@mui/icons-material/Info";

const itemgraphers = [
  {
    name: "Satish Mishra Guru Ji",
    location: "North Bangalore, Bangalore",
    language: "Kannada",
    price: "$11,000 ",
    rating: "5.0",
    reviews: 251,
    options: ["5 Years + of experience", "Kannada", "English", "Tamil"],
    img: k1,
  },
  {
    name: "Pandit Shree Hari Krish",
    location: "Bangalore",
    language: "Tamil",
    price: "$15,000",
    rating: "5.0",
    reviews: 251,
    options: ["5 Years + of experience", "Kannada", "English", "Tamil"],
    img: k2,
  },
  {
    name: "Rhythm Beats",
    location: "Mumbai",
    language: "Telugu",
    price: "$12,500",
    rating: "5.0",
    reviews: 251,
    options: ["5 Years + of experience", "Kannada", "English", "Tamil"],
    img: k1,
  },
  {
    name: "Step Up Crew",
    location: "Delhi",
    price: "$18,000 ",
    language: "Kannada",
    rating: "5.0",
    reviews: 251,
    options: ["5 Years + of experience", "Kannada", "English", "Tamil"],
    img: k2,
  },
  {
    name: "Satish Mishra Guru Ji",
    location: "North Bangalore, Bangalore",
    language: "Kannada",
    price: "$11,000 ",
    rating: "5.0",
    reviews: 251,
    options: ["5 Years + of experience", "Kannada", "English", "Tamil"],
    img: k1,
  },
  {
    name: "Pandit Shree Hari Krish",
    location: "Bangalore",
    language: "Tamil",
    price: "$15,000",
    rating: "5.0",
    reviews: 251,
    options: ["5 Years + of experience", "Kannada", "English", "Tamil"],
    img: k2,
  },
  {
    name: "Rhythm Beats",
    location: "Mumbai",
    language: "Telugu",
    price: "$12,500",
    rating: "5.0",
    reviews: 251,
    options: ["5 Years + of experience", "Kannada", "English", "Tamil"],
    img: k1,
  },
  {
    name: "Step Up Crew",
    location: "Delhi",
    price: "$18,000 ",
    language: "Kannada",
    rating: "5.0",
    reviews: 251,
    options: ["5 Years + of experience", "Kannada", "English", "Tamil"],
    img: k2,
  },
];

const ServiceListing = () => {
  // Track which card’s "More" popover is open
  const [moreAnchor, setMoreAnchor] = useState(null);
  const [moreIndex, setMoreIndex] = useState(null);

  // Track which card’s "Info" popover is open
  const [infoAnchor, setInfoAnchor] = useState(null);
  const [infoIndex, setInfoIndex] = useState(null);

  return (
    <>
      <Header />
      <Grid
        container
        spacing={4}
        sx={{ p: { xs: 2, md: 6 }, alignItems: "center", mt: 10 }}
      >
        <Typography
          sx={{
            fontSize: 24,
            fontWeight: "bold",

            width: "100%",
          }}
        >
          Wedding Pandits / Priests in Bangalore
        </Typography>

        {itemgraphers.map((item, index) => (
          <Grid key={index} size={{ xs: 12, md: 4 }}>
            <Card
              sx={{
                borderRadius: 2,
                boxShadow: 3,
                mx: "auto",
                ":hover": {
                  boxShadow: 10,
                },
              }}
            >
              <Box sx={{ position: "relative" }}>
                <CardMedia
                  component="img"
                  image={item.img}
                  alt={item.name}
                  sx={{ height: 250, objectFit: "cover", width: "100%" }}
                />
                <IconButton
                  sx={{
                    position: "absolute",
                    bottom: 5,
                    right: 5,
                    bgcolor: "#f5f5f5",
                    boxShadow: 2,
                    // "&:hover": { bgcolor: "grey.100" },
                  }}
                  onClick={(e) => {
                    setInfoAnchor(e.currentTarget);
                    setInfoIndex(index);
                  }}
                >
                  <InfoIcon sx={{ color: "#555" }} />
                </IconButton>

                <Popover
                  open={infoIndex === index}
                  anchorEl={infoAnchor}
                  onClose={() => setInfoIndex(null)}
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  transformOrigin={{ vertical: "bottom", horizontal: "right" }}
                  PaperProps={{
                    sx: {
                      bgcolor: "rgba(255,255,255,0.80)",
                      color: "black",
                      p: 2,
                      borderRadius: 2,
                      boxShadow: 3,
                      width: 300,
                    },
                  }}
                >
                  <Typography sx={{ fontWeight: "bold" }}>
                    About vendor
                  </Typography>
                  <Typography sx={{ fontSize: 13 }}>
                    This is a description area where you can add details about
                    the image, service, or person. It appears in a white
                    transparent layer when the info icon is clicked.
                  </Typography>
                </Popover>
              </Box>

              {/* Card Content */}
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    justifyContent: "space-between",
                  }}
                >
                  <Typography sx={{ fontWeight: "bold", fontSize: 16 }}>
                    {item.name}
                  </Typography>

                  <Typography
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      fontSize: 14,
                    }}
                  >
                    <StarIcon sx={{ color: "green", fontSize: 18 }} />
                    {item.rating} ({item.reviews} Reviews)
                  </Typography>
                </Box>

                <Typography
                  sx={{
                    color: "#909090",
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    fontSize: 14,
                    ml: -0.5,
                    mt: 1,
                  }}
                >
                  <LocationOnIcon sx={{ fontSize: 15, color: "#909090" }} />
                  {item.location}
                </Typography>

                <Typography
                  sx={{
                    fontWeight: "bold",
                    mt: 1,
                    fontSize: 17,
                    color: "#333",
                  }}
                >
                  ₹ {item.price} onwards
                </Typography>

                {/* Options */}
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      bgcolor: "#f3f3f3",
                      py: 0.2,
                      px: 0.6,
                    }}
                  >
                    5 Years + of experience
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 12,
                      bgcolor: "#f3f3f3",
                      py: 0.2,
                      px: 0.6,
                    }}
                  >
                    {item.language}
                  </Typography>

                  {/* +3 More */}
                  <Typography
                    onClick={(e) => {
                      setMoreAnchor(e.currentTarget);
                      setMoreIndex(index);
                    }}
                    sx={{
                      fontSize: 12,
                      textDecoration: "underline",
                      cursor: "pointer",
                      textUnderlineOffset: 3,
                    }}
                  >
                    +3 More
                  </Typography>

                  {/* More Popover */}
                  <Popover
                    open={moreIndex === index}
                    anchorEl={moreAnchor}
                    onClose={() => setMoreIndex(null)}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    PaperProps={{
                      sx: {
                        bgcolor: "rgba(0, 0, 0, 0.7)", // semi-transparent black
                        color: "white",
                        py: 2,
                        px: 3,
                        borderRadius: 2,
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                      },
                    }}
                  >
                    {item.options.map((option, idx) => (
                      <Box key={idx} sx={{ display: "flex", gap: 1 }}>
                        <Typography variant="body2">•</Typography>
                        <Typography sx={{ fontSize: 13 }}>{option}</Typography>
                      </Box>
                    ))}
                  </Popover>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Footer />
    </>
  );
};

export default ServiceListing;

